export default Backbone.Model.extend({
    defaults: {
        iconClass: 'filter',
        draggable: false,
        triggerBeforeOpen: false
    }
});
